import request from 'superagent';

export default {

    likeDesign(context, { designId, designLikeUrl, csrfToken }) {
        request
            .post(designLikeUrl)
            .set('Accept', 'application/json')
            .set('X-CSRF-Token', csrfToken)
            .end((err, res) => {
                context.dispatch(
                    'UPDATE_DESIGN_SUCCESS',
                    {
                        designId,
                        likeCount: res.body.likeCount,
                        likedByUser: true,
                    },
                );
            });
    },

    unlikeDesign(context, { designId, designLikeUrl, csrfToken }) {
        request
            .delete(designLikeUrl)
            .set('Accept', 'application/json')
            .set('X-CSRF-Token', csrfToken)
            .end((err, res) => {
                context.dispatch(
                    'UPDATE_DESIGN_SUCCESS',
                    {
                        designId,
                        likeCount: res.body.likeCount,
                        likedByUser: false,
                    },
                );
            });
    },
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/actions/DesignDetailsActionCreators.js